import { PhitoRoute, PhitoRoutes } from '../../app/app/phito-routes';
import { PermissionAction } from '../administration/role-and-permissions/role-and-permission';

export const DOCUMENTATION_ROUTES = {
    overview: new PhitoRoute(
        'Dokumentationen',
        'book_2',
        PermissionAction.Ansehen('Documents', 'Dokumentation'),
        'documents/documentations',
        () => ['documents', 'documentations'],
        import('./documentation-overview/documentation-overview.component').then(
                (mod) => mod.DocumentationOverviewComponent,
            )
    ),
    details: new PhitoRoute(
        'Dokumentation Details',
        'book_2',
        PermissionAction.Ansehen('Documents', 'Dokumentation'),
        'documents/documentations/:id',
        (documentationId: string) => ['documents', 'documentations', documentationId],
import(
                './documentation-overview/documentation-details/documentation-details.component'
            ).then((mod) => mod.DocumentationDetailsComponent),
    )
} satisfies PhitoRoutes